import { UPDATE_SOUND_STATUS } from '../constants'

type SoundStatus = {
    [ruleId: string]: boolean
}

export default (soundStatus: SoundStatus): { type: string; soundStatus: SoundStatus } => ({
    type: UPDATE_SOUND_STATUS,
    soundStatus
})
